/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { OLAF } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import MobileSearchBar from 'ecosystem-marketplace-core/components/storefront/MobileSearchBar';
import MobileTypeaheadResults from 'ecosystem-marketplace-core/components/mobile/MobileTypeaheadResults';
import MobilePanel from 'ecosystem-marketplace-core/js/components/mobile/MobilePanel';
import MobilePanelBody from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelBody';
import { debounce } from 'ecosystem-marketplace-core/utils/debounce';
import globalNavHeight from 'nav-meta/global-nav-height';
import StorefrontUsageTrackerContext from '../context/StorefrontUsageTrackerContext';
const INNER_SEARCH_CLASS = 'inner-search-bar';
const StyledStickySearchBarWrapper = styled.div.withConfig({
  displayName: "MobileStorefrontHeader__StyledStickySearchBarWrapper",
  componentId: "kdwtbz-0"
})(["&&{position:fixed;z-index:9999;top:0;left:0;width:100%;height:", ";padding:5px 8px;background-image:linear-gradient( ", ",", ",", " );}"], globalNavHeight, props => props.gradientAngle || '-303deg', props => props.startGradientColor, props => props.endGradientColor);

const MobileStorefrontHeader = ({
  className,
  customStyle,
  placeholder,
  searchTerm,
  onClearSearch,
  onSearchSubmit,
  loadOptions,
  onSelectedOptionChange
}) => {
  const {
    focusMobileFilterButton
  } = useContext(StorefrontUsageTrackerContext);
  const {
    GRADIENT_ANGLE,
    START_GRADIENT_COLOR,
    END_GRADIENT_COLOR
  } = customStyle;
  const [mobileSearchBarFocused, setMobileSearchBarFocused] = useState(false);
  const [mobileTypeaheadOpen, setMobileTypeaheadOpen] = useState(false);
  const [mobileTypeaheadResults, setMobileTypeaheadResults] = useState([]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const fetchTypeaheadResults = useCallback(searchValue => {
    loadOptions(searchValue.toLowerCase(), (__notUsedVar, {
      options
    }) => {
      setMobileTypeaheadResults(options);
    });
  }, [loadOptions]);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
  const searchSubmit = useCallback(value => {
    setMobileTypeaheadOpen(false);
    setMobileTypeaheadResults([]);
    onSearchSubmit(value);
    focusMobileFilterButton();
  }, [onSearchSubmit]);
  const focusMobileSearchBar = useCallback(evt => {
    setMobileSearchBarFocused(true);
    setMobileTypeaheadOpen(true);

    if (evt.target.value && !mobileTypeaheadResults.length) {
      fetchTypeaheadResults(evt.target.value);
    }
  }, [fetchTypeaheadResults, mobileTypeaheadResults]);
  const cancelMobileSearch = useCallback(() => {
    setMobileSearchBarFocused(false);
    setMobileTypeaheadOpen(false);
    focusMobileFilterButton();
  }, []);
  const selectMobileTypeaheadItem = useCallback(item => {
    onClearSearch();
    setMobileSearchBarFocused(false);
    setMobileTypeaheadOpen(false);
    onSelectedOptionChange({
      target: {
        value: item
      }
    });
  }, [onClearSearch, onSelectedOptionChange]);
  const onSearchUpdate = useCallback(debounce(searchValue => {
    fetchTypeaheadResults(searchValue);
    setLocalSearchTerm(searchValue);
  }), [fetchTypeaheadResults]);
  const focusInnerSearchOnPanelOpen = useCallback(() => {
    const innerSearchBar = document.querySelector(`.${INNER_SEARCH_CLASS}`);

    if (innerSearchBar) {
      const innerSearchInput = innerSearchBar.querySelector('.mobile-search-input');

      if (innerSearchInput) {
        innerSearchInput.focus();
      }
    }
  }, []);
  const onPanelOpen = useCallback(() => {
    setScrollPosition(window.scrollY);

    window.onscroll = () => {
      window.scrollTo(0, 0);
    };
  }, []);
  const onPanelClose = useCallback(() => {
    window.onscroll = () => {};

    window.scrollTo(0, scrollPosition);
  }, [scrollPosition]);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(UIFlex, {
      justify: "end",
      children: /*#__PURE__*/_jsx(UIIconButton, {
        onClick: focusMobileSearchBar,
        use: "transparent",
        placement: "right",
        children: /*#__PURE__*/_jsx(UIIcon, {
          color: OLAF,
          name: "search"
        })
      })
    }), /*#__PURE__*/_jsx(MobilePanel, {
      onOpenStart: onPanelOpen,
      onOpenComplete: focusInnerSearchOnPanelOpen,
      onCloseStart: onPanelClose,
      open: mobileTypeaheadOpen,
      align: "top",
      children: /*#__PURE__*/_jsxs(MobilePanelBody, {
        children: [/*#__PURE__*/_jsx(StyledStickySearchBarWrapper, {
          gradientAngle: GRADIENT_ANGLE,
          startGradientColor: START_GRADIENT_COLOR,
          endGradientColor: END_GRADIENT_COLOR,
          children: /*#__PURE__*/_jsx(MobileSearchBar, {
            className: INNER_SEARCH_CLASS,
            cancelSearch: cancelMobileSearch,
            focused: mobileSearchBarFocused || mobileTypeaheadOpen,
            inputValue: localSearchTerm,
            onClear: onClearSearch,
            onSearchFocus: focusMobileSearchBar,
            onSearchSubmit: searchSubmit,
            onSearchUpdate: onSearchUpdate,
            placeholder: placeholder
          })
        }), /*#__PURE__*/_jsx(MobileTypeaheadResults, {
          options: mobileTypeaheadResults,
          onChange: selectMobileTypeaheadItem
        })]
      })
    })]
  });
};

MobileStorefrontHeader.propTypes = {
  className: PropTypes.string,
  customStyle: PropTypes.shape({
    MAIN_SECTION_CLASSNAME: PropTypes.string.isRequired,
    BACKGROUND_COLOR: PropTypes.string.isRequired,
    GRADIENT_ANGLE: PropTypes.string,
    START_GRADIENT_COLOR: PropTypes.string.isRequired,
    END_GRADIENT_COLOR: PropTypes.string.isRequired
  }),
  loadOptions: PropTypes.func.isRequired,
  onClearSearch: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
  onSelectedOptionChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  searchTerm: PropTypes.string
};
export default MobileStorefrontHeader;